// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"377a6433","181":"43351d55","281":"876928aa","398":"a4e1d41f","453":"95c5e987","971":"e447bb3c"}[chunkId] + ".chunk.js";
};